
interface Doge {
  name: string;
  age: number;
}

import { reactive, computed } from "vue";
import MyButton from "@/components/MyButton.vue";
import { useInformation } from "@/store/store";

export default {
  components: {
    MyButton
  },
  setup() {
    const { setMessage } = useInformation();

    const doge = reactive<Doge>({
      name: "bob",
      age: 0
    });

    const countUp = (v: number) => {
      doge.age += v;
      setMessage(`You add count: ${v} amounts:${doge.age}`);
    };

    const getDoge = (v: any) => {
      console.log(v);
    };

    const over9000 = computed(() => {
      return doge.age >= 9000;
    });

    return {
      doge,
      countUp,
      getDoge,
      over9000
    };
  }
};
